var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("button", {
    staticClass: "mdi mdi-close cursor-pointer focus:outline-none",
    attrs: { type: "button" },
    on: {
      click: function ($event) {
        return _vm.$emit("remove")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }